import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import moment from "moment";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Form,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Formik, Field, ErrorMessage } from "formik";
import debounce from "lodash/debounce";
import "assets/scss/table.scss";

//Import Breadcrumb
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  // getSchemeAnalytesList,
  getResultAnalyteData,
  postResult,
  getResultsList,
} from "store/results/actions";
// import { getunitlist } from "store/units/actions";
// import { getmethodlist } from "store/methods/actions";
// import { getInstrumentlist } from "store/instrument/actions";
// import { getReagentlist } from "store/reagents/actions";
import * as XLSX from "xlsx";

import "assets/scss/table.scss";
import { round } from "lodash";
import CycleList from "store/cycle/reducer";
import { propTypes } from "react-bootstrap/esm/Image";

class Results extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      rating: null,
      conditionRatings: {},
      ReagentList: [],
      Instrument: [],
      ListMethods: [],
      ListUnits: [],
      SchemeAnalytesList: [],
      validationErrors: {},
      combinedData: [],
      list: "",
      units: "",
      instrument_name: "",
      sample_condition: "",
      method_name: "",
      reagent_name: "",
      result_type: "",
      result: "",
      schemeName: "",
      schemeType: "",
      comments: "",
      roundLoadedFor: null, // Add this field
      loading: true, // 🔄 Track loading status
      roundLoadedFor: null,
      round_status: "",
      result_status: "Created",
      rounds: "",
      issue_date: "",
      closing_date: "",
      cycle_no: "",
      isResubmitted: false,

      PostResult: [],
      currentRoundId: props.match.params.id, // Track the round ID in state
      ResultList: [],
      filters: {
        name: "",
        landline: "",
        email: "",
        address: "",
        city: "",
        type: "",
      },
      currentPage: 1,
      itemsPerPage: 50,
      isDataLoaded: false, // Flag to track if all data is loaded
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      // approvedLabListColumns: this.getApprovedLabListColumns(), // Initialize columns in state
    };
  }
  fetchResults = async () => {
    try {
      const id = this.props.match.params.id;
      console.log("🔄 Fetching latest results...");

      // Call the Redux action to fetch latest results
      await this.props.onGetResultsList(id);

      console.log("✅ Latest results fetched");
    } catch (error) {
      console.error("❌ Error fetching results", error);
    }
  };

  getBarStatus = rating => {
    if (!rating) return null;
    if (rating === 1 || rating === 2) return "Low";
    if (rating === 3) return "Medium";
    if (rating >= 4) return "High";
    return null;
  };
  getApprovedLabListColumns = () => {
    const { schemeType, round_status, SchemeAnalytesList } = this.props;

    if (schemeType === "Quantitative") {
      return [
        {
          text: "Analyte",
          dataField: "analyte_name",
          headerStyle: {
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: {
            backgroundColor: "#a6d4ff", // Grayish for cells
          },
          sort: true,
        },
        {
          text: "Unit",
          dataField: "unit_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.unit_id || ""}
              onChange={e => this.handleUnitChange(e, row)}
            >
              <option value="">Select Unit</option>
              {(row.availableUnits || []).map(unit => (
                <option
                  key={`${row.analyte_id}_unit_${unit.id}`}
                  value={unit.id}
                >
                  {unit.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Instrument",
          dataField: "instrument_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.instrument_id || ""}
              onChange={e => this.handleInstrumentChange(e, row)}
            >
              <option value="">Select Instrument</option>
              {(row.availableInstruments || []).map(instr => (
                <option
                  key={`${row.analyte_id}_instr_${instr.id}`}
                  value={instr.id}
                >
                  {instr.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Method",
          dataField: "method_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.method_id || ""}
              onChange={e => this.handleMethodChange(e, row)}
            >
              <option value="">Select Method</option>
              {(row.availableMethods || []).map(method => (
                <option
                  key={`${row.analyte_id}_method_${method.id}`}
                  value={method.id}
                >
                  {method.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Reagent",
          dataField: "reagent_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.reagent_id || ""}
              onChange={e => this.handleReagentChange(e, row)}
            >
              <option value="">Select Reagent</option>
              {(row.availableReagents || []).map((reagent, idx) => (
                <option
                  key={`${row.analyte_id}_reagent_${reagent.id}_${idx}`}
                  value={reagent.id}
                >
                  {reagent.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Result Value",
          dataField: "result",
          formatter: (cell, row) => {
            const errorMessage = this.state.validationErrors?.[row.analyte_id];

            return (
              <div>
                <input
                  type="text"
                  className={`form-control ${errorMessage ? "is-invalid" : ""}`}
                  ref={el => (this[`resultRef_${row.analyte_id}`] = el)}
                  defaultValue={row.result || ""}
                  placeholder="Enter result"
                  onChange={() => {
                    // ONLY clear validation (do NOT update state here)
                    if (errorMessage) {
                      this.setState(prev => {
                        const errors = { ...prev.validationErrors };
                        delete errors[row.analyte_id];
                        return { validationErrors: errors };
                      });
                    }
                  }}
                  onBlur={e => {
                    const value = e.target.value.trim();

                    const updatedData = this.state.combinedData.map(item =>
                      item.analyte_id === row.analyte_id
                        ? { ...item, result: value }
                        : item
                    );

                    this.setState({ combinedData: updatedData });
                  }}
                />

                {errorMessage && (
                  <div className="invalid-feedback d-block">{errorMessage}</div>
                )}
              </div>
            );
          },
        },
      ];
    }

    if (schemeType === "Qualitative") {
      return [
        {
          text: "Analyte",
          dataField: "analyte_name",
          sort: true,
          headerStyle: {
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: {
            backgroundColor: "#a6d4ff", // Grayish for cells
          },
        },
        {
          text: "Instrument",
          dataField: "instrument_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.instrument_id || ""}
              onChange={e => this.handleInstrumentChange(e, row)}
            >
              <option value="">Select Instrument</option>
              {(row.availableInstruments || []).map(instr => (
                <option
                  key={`${row.analyte_id}_instr_${instr.id}`}
                  value={instr.id}
                >
                  {instr.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Method",
          dataField: "method_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.method_id || ""}
              onChange={e => this.handleMethodChange(e, row)}
            >
              <option value="">Select Method</option>
              {[
                ...new Map(
                  (row.availableMethods || []).map(m => [m.id, m])
                ).values(),
              ].map(method => (
                <option
                  key={`${row.analyte_id}_method_${method.id}`}
                  value={method.id}
                >
                  {method.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Reagent",
          dataField: "reagent_name",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.reagent_id || ""}
              onChange={e => this.handleReagentChange(e, row)}
            >
              <option value="">Select Reagent</option>
              {(row.availableReagents || []).map((reagent, idx) => (
                <option
                  key={`${row.analyte_id}_reagent_${reagent.id}_${idx}`}
                  value={reagent.id}
                >
                  {reagent.name}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Result Type",
          dataField: "result_type",
          formatter: (cell, row) => (
            <select
              className="form-select me-2"
              value={row.result_type || ""}
              onChange={e => this.handleResultTypeChange(e, row)}
            >
              <option value="">Select Result Type</option>
              {["Positive", "Negative", "Equivocal"].map(type => (
                <option key={`${row.analyte_id}_type_${type}`} value={type}>
                  {type}
                </option>
              ))}
            </select>
          ),
        },
        {
          text: "Result Value",
          dataField: "result",
          formatter: (cell, row) => (
            <input
              type="text"
              className="form-control"
              ref={el => (this[`resultRef_${row.analyte_id}`] = el)}
              defaultValue={row.result || ""}
              placeholder="Enter result"
              onBlur={e => {
                const value = e.target.value.trim();
                const updatedData = this.state.combinedData.map(item =>
                  item.analyte_id === row.analyte_id
                    ? { ...item, result: value }
                    : item
                );
                this.setState({ combinedData: updatedData });
              }}
            />
          ),
        },
      ];
    }
    return [];
  };
  // }
  componentDidMount() {
    this._isMounted = true; // ✅ mark as mounted

    const { onGetResultAnalyteData, onGetResultsList } = this.props;
    const roundId = this.props.match.params.id;

    const searchParams = new URLSearchParams(this.props.location.search);
    const participantIDFromQuery = searchParams.get("participantID");

    const userAuth = localStorage.getItem("authUser");
    const userId = userAuth ? JSON.parse(userAuth).user_id : null;
    const participantID = participantIDFromQuery || userId;

    console.log(
      "componentDidMount — roundId:",
      roundId,
      "participantID:",
      participantID
    );

    if (participantID) {
      this.setState({ participantID }, () => {
        if (roundId) {
          onGetResultAnalyteData(roundId);
          onGetResultsList(roundId);
        }
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false; // ✅ mark as unmounted
  }

  // Method to track fetched data after state is updated
  trackFetchedData() {
    console.log("Methods List:", this.state.ListMethods);
    console.log("Instrument List:", this.state.Instrument);
    console.log("Reagents List:", this.state.ReagentList);
    console.log("Units List:", this.state.UnitsList);
    console.log("Scheme Analyte List:", this.state.SchemeAnalytesList);
    console.log("Results List:", this.state.ResultsList);
  }
  componentDidUpdate(prevProps) {
    console.log("🔥 componentDidUpdate called");

    const { ResultAnalyteData, ResultList } = this.props;
    const currentRoundId = this.props.match.params.id;
    const prevRoundId = prevProps.match.params.id;

    if (prevRoundId !== currentRoundId) {
      console.log("🔁 Round changed:", prevRoundId, "→", currentRoundId);
      this.props.onGetResultAnalyteData(currentRoundId);
      this.props.onGetResultsList(currentRoundId);
    }

    const analytesLoaded =
      Array.isArray(ResultAnalyteData) && ResultAnalyteData.length > 0;

    // 🔎 Debug logs
    console.log("Prev analytes:", prevProps.ResultAnalyteData);
    console.log("Current analytes:", ResultAnalyteData);
    console.log("Prev results:", prevProps.ResultList);
    console.log("Current results:", ResultList);

    if (prevProps.ResultList !== ResultList) {
      const resultsArray = Array.isArray(ResultList)
        ? ResultList
        : ResultList?.data || [];

      if (resultsArray.length > 0) {
        const latestSubmitted = this.getLatestSubmittedTime(resultsArray);

        this.setState({
          labName: resultsArray[0].lab?.name || "",
          participantID: resultsArray[0].lab_id || this.state.participantID,
          submittedOn: latestSubmitted ? latestSubmitted.toISOString() : null,
        });
      }
    }

    if (
      analytesLoaded &&
      (JSON.stringify(prevProps.ResultAnalyteData) !==
        JSON.stringify(ResultAnalyteData) ||
        JSON.stringify(prevProps.ResultList) !== JSON.stringify(ResultList))
    ) {
      console.log("🔄 Combining analytes + results...");
      this.combineData();
    }
  }

  combineData = () => {
    console.log("🛠 combineData() called");
    console.log(
      "🔄 combineData called, current rating in state:",
      this.state.rating
    );

    const {
      ResultAnalyteData,
      ResultList,
      units,
      methods,
      instruments,
      reagents,
    } = this.props;

    if (!ResultAnalyteData?.length) {
      console.log("⏸ No analytes yet");
      return;
    }

    const resultsArray = Array.isArray(ResultList)
      ? ResultList
      : ResultList?.data || [];

    const combinedData = ResultAnalyteData.map(analyte => {
      const userResult = resultsArray.find(
        r => String(r.analyte) === String(analyte.id)
      );

      // filter lists based on analyte’s IDs
      const availableUnits = units.filter(u => analyte.units?.includes(u.id));
      const availableMethods = methods.filter(m =>
        analyte.methods?.includes(m.id)
      );
      const availableReagents = reagents.filter(r =>
        analyte.reagents?.includes(r.id)
      );
      const availableInstruments = instruments.filter(i =>
        i.analytes?.includes(analyte.id)
      );

      return {
        analyte_id: analyte.id,
        analyte_name: analyte.name,

        // selected values
        sample_condition: userResult?.sample_condition || null,
        result: userResult?.result || "",
        unit_id: userResult?.units || null,
        unit_name: userResult?.unit_name || "",
        method_id: userResult?.method || null,
        method_name: userResult?.method_name || "",
        instrument_id: userResult?.instrument || null,
        instrument_name: userResult?.instrument_name || "",
        reagent_id: userResult?.reagents || null,
        reagent_name: userResult?.reagent_name || "",
        result_type: userResult?.result_type || "",
        result_status: userResult?.result_status || "Created",
        rating: userResult?.rating || null,

        // ✅ comment for each analyte
        comment: userResult?.comment || "",

        // analyte-specific lists
        availableUnits: [...availableUnits].sort((a, b) =>
          a.name.localeCompare(b.name)
        ),
        availableMethods: [...availableMethods].sort((a, b) =>
          a.name.localeCompare(b.name)
        ),
        availableInstruments: [...availableInstruments].sort((a, b) =>
          a.name.localeCompare(b.name)
        ),
        availableReagents: [...availableReagents].sort((a, b) =>
          a.name.localeCompare(b.name)
        ),
      };
    });
    const savedSampleCondition =
      combinedData.find(d => d.sample_condition)?.sample_condition || "";

    console.log("📋 Final combinedData:", combinedData);
    // ✅ set comments state from the first analyte
    const savedRating = combinedData.find(d => d.rating)?.rating || null;

    this.setState(prevState => ({
      combinedData,
      loading: false,
      comments: combinedData.length > 0 ? combinedData[0].comment || "" : "",
      sample_condition: savedSampleCondition,
      rating: savedRating,
      conditionRatings: savedSampleCondition
        ? { [savedSampleCondition]: savedRating }
        : {},
    }));
  };

  handleSaveAll = async () => {
    const { combinedData, comments, user_id } = this.state;
    const { rounds, scheme_id, round_status, schemeType } = this.props;
    const id = this.props.match.params.id;

    if (!combinedData.length) {
      alert("No results to save.");
      return;
    }

    const confirmation = window.confirm(
      "Are you sure you want to save all results?"
    );
    if (!confirmation) return;

    try {
      for (const row of combinedData) {
        const resultValue = row.result?.trim() || "";
        const resultType = row.result_type;

        const hasResult = resultValue !== "";

        // ✅ VALIDATE ONLY IF RESULT IS ENTERED
        if (hasResult) {
          // 🔹 Qualitative → Result Type required
          if (
            schemeType === "Qualitative" &&
            (!resultType || resultType === "Not Submitted")
          ) {
            alert(`Please select Result Type for analyte: ${row.analyte_name}`);
            return;
          }

          // 🔹 Required fields when result exists
          if (
            !row.instrument_id ||
            !row.method_id ||
            !row.reagent_id ||
            (schemeType === "Quantitative" && !row.unit_id)
          ) {
            alert(
              `Instrument, Method, Reagent${
                schemeType === "Quantitative" ? ", and Unit" : ""
              } are required when Result is entered for analyte: ${
                row.analyte_name
              }`
            );
            return;
          }
        }

        // ✅ SAVE DATA (even if result is empty)
        const resultData = {
          round_id: id,
          analyte_id: row.analyte_id,
          units: row.unit_id || null,
          instrument: row.instrument_id || null,
          method: row.method_id || null,
          reagents: row.reagent_id || null,
          result_type: resultType || null,
          sample_condition: this.state.sample_condition || "",
          result: resultValue,
          rounds,
          scheme_id,
          round_status,
          result_status: "Saved",
          comment: comments || "",
          rating: this.state.rating || null,
          bar_status: this.getBarStatus(this.state.rating) || "",
        };

        await this.props.onPostResult(resultData, user_id);
      }

      alert("All results have been saved successfully.");
      window.location.reload();
    } catch (error) {
      alert("Failed to save all results. Please try again.");
    }
  };
  handleSubmitAll = async () => {
    const { combinedData, comments, user_id } = this.state;
    const { schemeType, rounds, scheme_id, round_status } = this.props;
    const id = this.props.match.params.id;

    let hasError = false;
    const newErrors = {};

    // 🔍 VALIDATION PASS
    combinedData.forEach(row => {
      const resultValue = row.result?.trim() || "";
      const hasResult = resultValue !== "";

      if (hasResult) {
        // 🔹 Required fields when result exists
        if (
          !row.instrument_id ||
          !row.method_id ||
          !row.reagent_id ||
          (schemeType === "Quantitative" && !row.unit_id)
        ) {
          newErrors[row.analyte_id] =
            "Instrument, Method, Reagent" +
            (schemeType === "Quantitative" ? ", and Unit" : "") +
            " are required when Result is entered";
          hasError = true;
        }

        // 🔹 Qualitative → Result Type required
        if (
          schemeType === "Qualitative" &&
          (!row.result_type || row.result_type === "Not Submitted")
        ) {
          newErrors[row.analyte_id] = "Please select Result Type";
          hasError = true;
        }
      }
    });

    this.setState({ validationErrors: newErrors });

    if (hasError) return; // ❌ stop submit

    // ✅ SUBMIT DATA
    try {
      for (const row of combinedData) {
        const resultData = {
          round_id: id,
          analyte_id: row.analyte_id,
          units: row.unit_id || null,
          instrument: row.instrument_id || null,
          method: row.method_id || null,
          reagents: row.reagent_id || null,
          result_type: row.result_type || null,
          sample_condition: this.state.sample_condition || "",
          result: row.result?.trim() || "",
          rounds,
          scheme_id,
          round_status,
          result_status: "Submitted",
          comment: comments || "",
          rating: this.state.rating || null,
          bar_status: this.getBarStatus(this.state.rating) || "",
        };

        await this.props.onPostResult(resultData, user_id);
      }

      alert("Results submitted successfully!");
      await this.fetchResults();
      this.combineData();
      this.setState({ validationErrors: {} });
    } catch (error) {
      alert("Failed to submit all results. Please try again.");
    }
  };
  handleResubmit = async () => {
    const { combinedData } = this.state;
    const { rounds, scheme_id, round_status, schemeType } = this.props;
    const id = this.props.match.params.id;

    if (!combinedData.length) {
      alert("No results to resubmit.");
      return;
    }

    const confirmation = window.confirm(
      "Are you sure you want to resubmit all results?"
    );
    if (!confirmation) return;

    try {
      let latestUpdatedAt = new Date().toISOString();

      for (const list of combinedData) {
        const resultValue = this[`resultRef_${list.analyte_id}`]?.value?.trim();
        const resultType = list.result_type;

        // ✅ Only validate if a result value is entered
        if (resultValue) {
          // 🔹 Result Type check ONLY for Qualitative schemes
          if (schemeType === "Qualitative") {
            if (
              !resultType ||
              resultType === "Not Submitted" ||
              resultType === ""
            ) {
              alert(
                `Please select a valid Result Type for analyte: ${list.analyte_name}`
              );
              return;
            }
          }

          // 🔹 Instrument, Method, and Reagent are required for BOTH types
          if (!list.instrument_id || !list.method_id || !list.reagent_id) {
            alert(
              `Please select Instrument, Method, and Reagent for analyte: ${list.analyte_name}`
            );
            return;
          }
        }

        const resultData = {
          round_id: id,
          analyte_id: list.analyte_id,
          units: list.unit_id || null,
          instrument: list.instrument_id || null,
          method: list.method_id || null,
          reagents: list.reagent_id || null,
          result_type: resultType || null,
          sample_condition: this.state.sample_condition || "",
          result: resultValue || "",
          rounds,
          scheme_id,
          round_status,
          result_status: "Submitted",
          comment: this.state.comments || "",
          rating: this.state.rating || null,
          bar_status: this.getBarStatus(this.state.rating) || "",
        };

        const response = await this.props.onPostResult(
          resultData,
          this.state.user_id
        );
        if (response.type === "POST_RESULT" && response.payload?.updated_at) {
          latestUpdatedAt = response.payload.updated_at;
        }
      }

      this.setState({ submittedOn: latestUpdatedAt });

      alert("Results resubmitted successfully!");
      await this.fetchResults();
      this.combineData();
    } catch (error) {
      alert("Failed to resubmit results. Please try again.");
    }
  };
  getLatestSubmittedTime = (results = []) => {
    return results
      .filter(r => r.result_status === "Submitted" && r.updated_at)
      .map(r => new Date(r.updated_at))
      .sort((a, b) => b - a)[0];
  };
  handleUnitChange = (event, row) => {
    const selectedId = parseInt(event.target.value);
    const selectedUnit = (this.props.units || []).find(
      u => u.id === selectedId
    );

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? { ...item, unit_id: selectedId, unit_name: selectedUnit?.name || "" }
        : item
    );

    this.setState({ combinedData: updatedData });
  };

  handleMethodChange = (event, row) => {
    const selectedId = parseInt(event.target.value);
    const selectedMethod = (this.props.methods || []).find(
      m => m.id === selectedId
    );

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? {
            ...item,
            method_id: selectedId,
            method_name: selectedMethod?.name || "",
          }
        : item
    );

    this.setState({ combinedData: updatedData });
  };

  handleInstrumentChange = (event, row) => {
    const selectedId = parseInt(event.target.value);
    const selectedInstrument = (this.props.instruments || []).find(
      i => i.id === selectedId
    );

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? {
            ...item,
            instrument_id: selectedId,
            instrument_name: selectedInstrument?.name || "",
          }
        : item
    );

    this.setState({ combinedData: updatedData });
  };

  handleReagentChange = (event, row) => {
    const selectedId = parseInt(event.target.value);
    const selectedReagent = (this.props.reagents || []).find(
      r => r.id === selectedId
    );

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? {
            ...item,
            reagent_id: selectedId,
            reagent_name: selectedReagent?.name || "",
          }
        : item
    );

    this.setState({ combinedData: updatedData });
  };

  handleResultTypeChange = (e, row) => {
    const newResultType = e.target.value;

    const updatedData = this.state.combinedData.map(item =>
      item.analyte_id === row.analyte_id
        ? { ...item, result_type: newResultType }
        : item
    );

    this.setState({ combinedData: updatedData });
  };
  // handleReagentChange = (event, list) => {
  //   const { value } = event.target;
  //   const { combinedData } = this.state;

  //   const updatedData = combinedData.map(item => {
  //     if (item.id === list.id) {
  //       return { ...item, reagent_name: value };
  //     }
  //     return item;
  //   });

  //   this.setState({ combinedData: updatedData });
  // };

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  exportToExcel = () => {
    const { ResultList } = this.props;
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    // Define fields to export
    const fieldsToExport = [
      "id",
      "analyte",
      "units",
      "instrument",
      "method",
      "reagents",
      "result",
      "result_status",
      "result_type",
    ];

    // Map each row to an object with only the desired fields
    const dataToExport = ResultList.map(unit => ({
      id: unit.id,
      Analyte: unit.analyte,
      Unit: unit.units,
      Instrument: unit.instrument,
      Method: unit.method,
      Reagent: unit.reagents,
      Result_Type: unit.result_type,
      Result: unit.result,
      Result_Status: unit.result_status,
    }));

    // Convert data to Excel format and save as file
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    const fileName = "Method_list" + fileExtension;
    saveAs(data, fileName);
  };
  handlePageChange = pageNumber => {
    this.setState({ currentPage: pageNumber }, () => {
      const { onGetResultsList } = this.props;
      const { user_id, currentPage, itemsPerPage, filters } = this.state;
      onGetResultsList(user_id, currentPage, itemsPerPage, filters);
    });
  };
  handleFilterChange = (field, value) => {
    this.setState(
      prevState => ({
        filters: {
          ...prevState.filters,
          [field]: value,
        },
        currentPage: 1, // reset page on filter change
      }),
      () => {
        const { currentPage, itemsPerPage, filters, user_id } = this.state;
        const roundId = this.props.match.params.id;

        // 🔄 Refresh both lists
        this.props.onGetResultsList(
          roundId,
          currentPage,
          itemsPerPage,
          filters
        );
        this.props.onGetSchemeAnalyte(
          roundId,
          currentPage,
          itemsPerPage,
          filters
        );
      }
    );
  };
  sortOptions = (options, key = "name") => {
    if (!options) return [];
    return [...options].sort((a, b) =>
      String(a[key]).localeCompare(String(b[key]))
    );
  };

  render() {
    const approvedLabListColumns = this.getApprovedLabListColumns();
    const id = this.props.match.params.id;
    const { SearchBar } = Search;

    const {
      filters,
      currentPage,
      itemsPerPage,
      combinedData,
      isDataLoaded,
      loading,
    } = this.state;
    const {
      schemeName,
      scheme_id,
      schemeType,
      rounds,
      issue_date,
      closing_date,
      cycle_no,
      round_status,
    } = this.props;

    console.log("Round Status:", round_status);

    if (loading) {
      return (
        <div className="text-center mt-5">
          <h5>Loading round data...</h5>
        </div>
      );
    }

    const totalPages = combinedData?.total_pages || 0;
    const combinedDatasData = combinedData || [];
    const shouldShowTable = true;

    const pageOptions = {
      sizePerPage: 30,
      totalSize: combinedDatasData.length,
      custom: true,
    };

    const pageRange = 3;
    let startPage = Math.max(1, currentPage - Math.floor(pageRange / 2));
    let endPage = Math.min(totalPages, startPage + pageRange - 1);
    if (endPage - startPage + 1 < pageRange) {
      startPage = Math.max(1, endPage - pageRange + 1);
    }

    const pageNumbers = Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    );
    const defaultSorted = [{ dataField: "analyte_name", order: "asc" }];
    const { organization_name } = this.props.match.params;
    const participant_id = this.props.match.params.id1;

    return (
      <React.Fragment>
        {schemeType ? (
          <div className="page-content">
            <MetaTags>
              <title>Participant Result | NEQAS</title>
            </MetaTags>
            <Container fluid>
              {/* Header Info */}
              <Row className="mb-3 text-danger">
                <strong>
                  <Col className="d-flex flex-wrap justify-content-md-around justify-content-sm-start p-3">
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Participant Name:</span>
                      <span>
                        {
                          <span>
                            {this.state.labName || this.state.participantID}
                          </span>
                        }
                      </span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Scheme - Cycle: </span>
                      <span>
                        {schemeName} - {cycle_no}
                      </span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Round No: </span>
                      <span>{rounds}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Issue Date:</span>
                      <span>{moment(issue_date).format("DD-MMM-YY")}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start p-2">
                      <span className="me-2">Closing Date: </span>
                      <span>{moment(closing_date).format("DD-MMM-YY")}</span>
                    </div>
                  </Col>
                </strong>
              </Row>

              {/* Action Buttons */}
              <div
                className="d-flex flex-wrap align-items-center gap-3 ms-5"
                style={{ minHeight: "90px" }}
              >
                <Button
                  onClick={this.exportToExcel}
                  className="btn btn-secondary"
                  style={{ minWidth: "140px" }}
                >
                  Download Results
                </Button>

                {round_status === "Open" && !this.state.isResubmitted && (
                  <>
                    {!(
                      combinedData.length > 0 &&
                      combinedData.every(
                        data => data.result_status === "Submitted"
                      )
                    ) ? (
                      <>
                        <Button
                          className="btn btn-success"
                          style={{ minWidth: "140px" }}
                          onClick={this.handleSaveAll}
                        >
                          Save
                        </Button>
                        <Button
                          className="btn btn-success"
                          style={{ minWidth: "140px" }}
                          onClick={this.handleSubmitAll}
                        >
                          Submit
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          className="btn btn-success"
                          style={{ minWidth: "140px" }}
                          onClick={this.handleResubmit}
                        >
                          Re-Submit
                        </Button>
                      </>
                    )}
                  </>
                )}

                {this.state.submittedOn &&
                  combinedData.some(
                    data => data.result_status === "Submitted"
                  ) && (
                    <div className="mb-3">
                      <strong>Submitted On:</strong>{" "}
                      {moment(this.state.submittedOn).format(
                        "DD-MMM-YY, hh:mm A"
                      )}
                    </div>
                  )}
              </div>

              {/* Table */}
              {/* Table */}
              <Row className="justify-content-center align-item-center">
                <Col lg="10">
                  <Card>
                    <CardBody>
                      {combinedDatasData.length === 0 ? (
                        <div className="text-center mt-5">
                          <h5>No results yet for this round.</h5>
                        </div>
                      ) : (
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="analyte_id"
                          columns={approvedLabListColumns}
                          data={combinedDatasData}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="analyte_id"
                              columns={approvedLabListColumns}
                              data={combinedDatasData}
                              search
                            >
                              {toolkitprops => (
                                <div className="table-responsive">
                                  <BootstrapTable
                                    id="printable-table"
                                    key={`table-${Object.keys(
                                      this.state.validationErrors
                                    ).join(",")}`}
                                    keyField="analyte_id"
                                    ref={this.node}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    rowClasses={row => `row-${row.analyte_id}`}
                                    classes={"table table-bordered "}
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                  />
                                  <div className="float-end">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                      onPageChange={this.onPaginationPageChange}
                                    />
                                  </div>
                                </div>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              {/* Sample Condition Dropdown */}

              {(Number(this.props.scheme_id) === 29 ||
                Number(this.props.scheme_id) === 30 ||
                Number(this.props.scheme_id) === 33 ||
                Number(this.props.scheme_id) === 32 ||
                Number(this.props.scheme_id) === 37) && (
                <Row className="mt-4 justify-content-center">
                  <Col lg="10">
                    <Card>
                      <CardBody
                        style={{
                          backgroundColor: "#a6d4ff",
                          borderRadius: "6px",
                          padding: "15px",
                        }}
                      >
                        {/* Pre-Analytical Assessment Note */}
                        <Row className="mb-3">
                          <Col>
                            <div
                              style={{
                                backgroundColor: "#f0f7ff",
                                border: "1px solid #b8d4f0",
                                borderLeft: "4px solid #2a7acc",
                                borderRadius: "6px",
                                padding: "14px 16px",
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  color: "#1a5a99",
                                  marginBottom: "6px",
                                }}
                              >
                                Pre-Analytical Assessment (Optional):
                              </p>
                              <p
                                style={{
                                  fontSize: "13px",
                                  color: "#313131",
                                  lineHeight: "1.6",
                                  marginBottom: "0",
                                }}
                              >
                                Participants are requested to record the
                                observed condition of the EQA sample at the time
                                of analysis. Pre-analytical verification is a
                                critical component of the total testing process
                                and plays a significant role in ensuring
                                accurate and reliable results. Documenting the
                                sample condition allows us to better interpret
                                performance outcomes and understand any
                                potential variables that may influence
                                analytical results. Furthermore this is also an
                                assessment of laboratory practices and staff
                                competency in pre-analytical evaluation. It
                                serves as a constructive measure to strengthen
                                training, awareness, and adherence to good
                                laboratory practices.
                              </p>
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-center g-3">
                          {/* Sample Condition */}
                          <Col lg="5" className="d-flex align-items-center">
                            <span
                              className="me-2"
                              style={{
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Select:{" "}
                              <span
                                style={{
                                  fontWeight: "normal",
                                  color: "#313131",
                                }}
                              >
                                {/* (Optional): */}
                              </span>
                            </span>
                            <select
                              id="sample_condition"
                              className="form-select mt-0"
                              value={this.state.sample_condition}
                              onChange={e => {
                                const newCondition = e.target.value;
                                this.setState(prevState => {
                                  const updatedConditionRatings = {
                                    ...prevState.conditionRatings,
                                    [prevState.sample_condition]:
                                      prevState.rating,
                                  };
                                  return {
                                    sample_condition: newCondition,
                                    conditionRatings: updatedConditionRatings,
                                    rating:
                                      updatedConditionRatings[newCondition] ||
                                      null,
                                  };
                                });
                              }}
                            >
                              <option value="">Select Sample Condition</option>
                              <option value="Clear">Clear</option>
                              <option value="Clotted">Clotted</option>
                              <option value="Hemolyzed">Hemolyzed</option>
                              <option value="Icteric">Icteric</option>
                              <option value="Lipemic">Lipemic</option>
                            </select>
                          </Col>

                          {/* Rating only show for Hemolyzed, Icteric, Lipemic */}
                          {["Hemolyzed", "Icteric", "Lipemic"].includes(
                            this.state.sample_condition
                          ) && (
                            <Col lg="5" className="d-flex align-items-center">
                              <span
                                className="me-2"
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Rating:
                              </span>
                              <div className="d-flex gap-1 align-items-end">
                                {[1, 2, 3, 4, 5].map(bar => (
                                  <div
                                    key={bar}
                                    onClick={() =>
                                      this.setState(prevState => ({
                                        rating: bar,
                                        conditionRatings: {
                                          ...prevState.conditionRatings,
                                          [prevState.sample_condition]: bar,
                                        },
                                      }))
                                    }
                                    style={{
                                      width: "8px",
                                      height: `${bar * 5}px`,
                                      backgroundColor:
                                        bar <= (this.state.rating || 0)
                                          ? "#28a745"
                                          : "#ccc",
                                      cursor: "pointer",
                                      transition: "0.2s",
                                    }}
                                  />
                                ))}
                                {this.state.rating && (
                                  <span className="ms-2 fw-bold">
                                    {this.getBarStatus(this.state.rating)}
                                  </span>
                                )}
                                {this.state.rating && (
                                  <span className="ms-2 text-muted">
                                    ({this.state.rating}/5)
                                  </span>
                                )}
                              </div>
                            </Col>
                          )}
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
              {/* Comments */}
              <Row className="mt-4 justify-content-center">
                <Col lg="10">
                  <Card>
                    <CardBody>
                      <Label for="comments">
                        <strong>Enter Comments</strong>
                      </Label>
                      <textarea
                        id="comments"
                        className="form-control mb-3"
                        rows="4"
                        placeholder="Write your comments here..."
                        value={this.state.comments}
                        onChange={e =>
                          this.setState({ comments: e.target.value })
                        }
                      />
                      <Button
                        color="primary"
                        onClick={async () => {
                          const { comments, combinedData } = this.state;
                          const { rounds, scheme_id, round_status } =
                            this.props;
                          const round_id = this.props.match.params.id;

                          // helper to clean invalid values
                          const safe = (val, fallback = null) => {
                            if (
                              val === undefined ||
                              val === null ||
                              val === "undefined" ||
                              val === ""
                            )
                              return fallback;
                            return val;
                          };

                          if (!combinedData.length) {
                            alert("No result data found to attach comment.");
                            return;
                          }

                          try {
                            for (const analyte of combinedData) {
                              const resultData = {
                                round_id,
                                analyte_id: analyte.analyte_id,
                                rounds,
                                scheme_id,
                                round_status,

                                // ✅ keep existing values safe
                                result: safe(analyte.result, ""),
                                result_status: safe(
                                  analyte.result_status,
                                  "Saved"
                                ),
                                units: safe(analyte.unit_id),
                                instrument: safe(analyte.instrument_id),
                                method: safe(analyte.method_id),
                                reagents: safe(analyte.reagent_id),
                                result_type: safe(
                                  analyte.result_type,
                                  "Not Submitted"
                                ),

                                // ✅ new comment
                                comment: comments || "",
                                rating: safe(analyte.rating, null),
                                bar_status: safe(
                                  this.getBarStatus(analyte.rating),
                                  ""
                                ),
                              };

                              await this.props.onPostResult(
                                resultData,
                                this.state.user_id
                              );
                            }

                            alert(
                              "Comment saved for all analytes without overwriting existing data."
                            );
                            await this.fetchResults();
                            this.combineData();
                          } catch (error) {
                            alert("Failed to save comment to backend.");
                          }
                        }}
                      >
                        Save Comment
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        ) : (
          <div>No scheme type available</div>
        )}
      </React.Fragment>
    );
  }
}
Results.propTypes = {
  match: PropTypes.object,
  schemeName: PropTypes.string,
  schemeType: PropTypes.string,
  cycle_no: PropTypes.string,
  history: PropTypes.object.isRequired,

  rounds: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  scheme_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  round_status: PropTypes.string,
  result_type: PropTypes.string,
  issue_date: PropTypes.string,
  closing_date: PropTypes.string,
  units: PropTypes.array,
  methods: PropTypes.array,
  reagents: PropTypes.array,
  instruments: PropTypes.array,

  ResultAnalyteData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      units: PropTypes.array,
      methods: PropTypes.array,
      reagents: PropTypes.array,
      instruments: PropTypes.array,
    })
  ),

  PostResult: PropTypes.array,
  ResultList: PropTypes.array,

  className: PropTypes.any,
  onGetResultAnalyteData: PropTypes.func,
  onPostResult: PropTypes.func,
  onUpdateResult: PropTypes.func,
  onGetResultsList: PropTypes.func,
  roundStatus: PropTypes.object,
  SchemeAnalytesList: PropTypes.array,
  onGetSchemeAnalyte: PropTypes.func,
  // onGetResultsList: PropTypes.func,
  location: PropTypes.object,
};
const mapStateToProps = state => {
  console.log("mapStateToProps — full state:", state);
  console.log("units from props:", state.SchemeAnalytesList?.units);
  console.log("methods from props:", state.SchemeAnalytesList?.methods);
  console.log("instruments from props:", state.SchemeAnalytesList?.instruments);
  console.log("reagents from props:", state.SchemeAnalytesList?.reagents);

  // ✅ define list once
  const list = state.SchemeAnalytesList || {};

  return {
    // Results + analytes
    ResultAnalyteData: list.ResultAnalyteData || [],
    ResultList: list.ResultList || [],

    // Metadata
    schemeName: list.schemeName || "",
    schemeType: list.schemeType || "",
    rounds: list.rounds || "",
    scheme_id: list.scheme_id || null,
    round_status: list.round_status || "",
    result_type: list.result_type || "",
    issue_date: list.issue_date || "",
    closing_date: list.closing_date || "",
    cycle_no: list.cycle_no || "",

    // ✅ Always arrays
    units: Array.isArray(list.units) ? list.units : [],
    methods: Array.isArray(list.methods) ? list.methods : [],
    instruments: Array.isArray(list.instruments) ? list.instruments : [],
    reagents: Array.isArray(list.reagents) ? list.reagents : [],
  };
};

const mapDispatchToProps = dispatch => ({
  // onGetSchemeAnalyte: id => dispatch(getSchemeAnalytesList(id)),
  onGetResultAnalyteData: id => dispatch(getResultAnalyteData(id)),
  onPostResult: (result, id) => dispatch(postResult(result, id)),
  onGetResultsList: (id, page, limit, filters) =>
    dispatch(getResultsList(id, page, limit, filters)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Results));
